import styled, { keyframes } from 'styled-components'

import ArBlogAuthor from '../ArBlogAuthor/ArBlogAuthor'
// ArComponents
import ArMonoTag from 'src/components/typography/ArMonoTag'
import ArParagraph from 'src/components/typography/ArParagraph'
import { Link } from 'gatsby'
import React from 'react'
import { media } from 'src/styles/styled-components'
import routesConfig from 'src/routes.config'

const rotate = keyframes`
  from {
    transform: scale(0.95);
    opacity: .5;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
`

const StyledContainer = styled(Link)`
  animation: ${ rotate } .15s ease-out;
  animation-delay: ${ ({ index }) => (index) / 30 }s;
  animation-fill-mode: forwards;
  margin-bottom: 40px;
  opacity: 0;
  transform: scale(0);
  width: 100%;
  ${ media.tablet`
  ` }
  ${ media.desktop`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  ` }
`

const StyledImage = styled.div`
  background-image: url(${ ({ image }) => image });
  background-position: center;
  background-size: cover;
  border-radius: 4px;
  height: 190px;
  margin-bottom: 10px;
  width: 100%;
  ${ media.tablet`
    height: 225px;
  ` }
  ${ media.desktop`
    height: 255px;
  ` }
`

const StyledDetailCategory = styled(ArMonoTag)`
  margin-right: 10px;
  padding-right: 10px;
`

const StyledHeading = styled.h2`
  font-size: 1.8rem;
  line-height: 1.55;
  margin-bottom: 10px;
  margin-top: 10px;
  ${ media.desktop`
    font-size: 2.8rem;
    line-height: 1.17;
    font-weight: ${ p => p.theme.fontWeight.primary.Light }
    margin-bottom: 20px;
  ` }
`

const StyledParagraph = styled(ArParagraph)`
  margin-bottom: 10px;
`

const StyledDetailsBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`

const StyledAuthor = styled.div`
  &:not(:last-of-type) {
    margin-right: 20px;    
  }
`

const ArBlogPost = ({ data, itemIndex, className }) => {
  return (
    <StyledContainer className={className} to={routesConfig.company.blog({ slug: data.slug })} index={itemIndex}>
      <div>
        <StyledImage image={data.thumbnail.url}/>
        <StyledDetailCategory>{data.category}</StyledDetailCategory>
        <StyledHeading>{data.title}</StyledHeading>
        <StyledParagraph>{data.description}</StyledParagraph>
      </div>
      <div>
        <StyledDetailsBox>
          {data.author.map(author => <StyledAuthor key={author.name}><ArBlogAuthor author={author} small /></StyledAuthor>)}
        </StyledDetailsBox>
      </div>
    </StyledContainer>
  )
}

export default ArBlogPost
